import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Button, ButtonProps, CircularProgress, Theme } from '@mui/material'

export type AsyncButtonProps = ButtonProps & {
  loading: boolean
}

export const AsyncButton = React.forwardRef(({ loading, ...otherProps }: AsyncButtonProps, _ref: any) => {
  const { classes } = useStyles()
  return (
    <div className={classes.iconContainer}>
      <Button {...otherProps} />
      {loading && <CircularProgress thickness={4} size={24} className={classes.buttonProgress} color="secondary" />}
    </div>
  )
})

AsyncButton.displayName = 'AsyncButton'

const useStyles = makeStyles()(({ palette }: Theme) => ({
  iconContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  buttonSuccess: {
    backgroundColor: palette.secondary.main,
    '&:hover': {
      backgroundColor: palette.secondary.dark,
    },
  },
}))
